export default __webpack_public_path__ + "static/media/delievers11.5fb303a8.png";